function extractDiagnosis(data) {
  if (data.length === 0) {
    return [];
  }
  const diagnoses = data.map((entry) => entry.diagnosis);
  return diagnoses;
}

function formatMedicalHistory(input) {
  if (input.length === 0) {
    return [];
  }
  return input.map((item) => item.condition);
}
function formatGeneralNotes(input) {
  if (input.length === 0) {
    return [];
  }
  return input.map((item) => item.generalnote);
}
function formatDieticianNotes(input) {
  if (input.length === 0) {
    return [];
  }
  return input.map((item) => item.dietnote);
}

function transformVitalData(vitals) {
  if (!vitals || vitals.length === 0) return [];

  const vitalMap = {
    "Body Temperature": "Temp",
    "Pulse": "Heart Rate",
    "Respiratory Rate": "Resp Rate",
    "Systolic Blood Pressure": "BP_systolic",
    "Diastolic Blood Pressure": "BP_diastolic",
    "Oxygen Saturation": "SPO2",
    "Weight": "Weight",
    "Height": "Height",
    "Fasting Blood Glucose": "Fasting Sugar",
    "Postprandial Blood Glucose": "Post-Prandial Sugar",
  };

  let data = {};
  let bpSystolic = null;
  let bpDiastolic = null;

  vitals.forEach((vital) => {
    const key = vitalMap[vital.vitalname] || vital.vitalname;
    if (key === "BP_systolic") {
      bpSystolic = vital.vitalvalue;
    } else if (key === "BP_diastolic") {
      bpDiastolic = vital.vitalvalue;
    } else {
      data[key] = `${vital.vitalvalue} ${vital.vitalunit || ''}`.trim();
    }
  });

  if (bpSystolic && bpDiastolic) {
    data["Bp"] = `${bpSystolic}/${bpDiastolic}`;
  }

  const sequence = [
    "Temp",
    "Heart Rate",
    "Resp Rate",
    "Bp",
    "SPO2",
    "Weight",
    "Height",
    "Fasting Sugar",
    "Post-Prandial Sugar"
  ];

  return sequence
    .filter(key => data[key])
    .map(key => ({ type: key, value: data[key] }));
}



function transformInvestigationData(investigations) {
  if (investigations.length === 0) {
    return [];
  }
  const transformedInvestigations = [];
  investigations.forEach((investigate) => {
    transformedInvestigations.push({
        type: investigate.eventtitle,
        value: investigate.actualresultvalue,
        unit: investigate.resultuom,
      });
    
  });
  return transformedInvestigations;
}
function transformFetchedDocuments(docs) {
  if (docs.length === 0) {
    return [];
  }
  const transformedDocuments = [];
  docs.forEach((doc) => {
    transformedDocuments.push({
        image: doc.documenturl? doc.imagepath + doc.documenturl: null
      });
    
  });
  return transformedDocuments;
}
function calculateAge(dob) {
  if (!dob) {
    return 0;
  }

  const dobDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDifference = today.getMonth() - dobDate.getMonth();
  const dayDifference = today.getDate() - dobDate.getDate();

  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }

  return age;
}

function calculateDateDifference(startDate, endDate) {
  if (!endDate) return -1;

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Calculate the difference in milliseconds
  const diffInMilliseconds = end - start;

  // Convert milliseconds to days
  const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24)) +1;

  console.log(diffInDays)

  return diffInDays;
}

function formatMedicines(input) {
  console.log('input: : : ', input)
  if (input.length === 0) {
    return [];
  }
  return input.map((item) => {
    return {
      name: item.medicinename,
      type: item.medicinetype,
      chemicalcomposition: item.chemicalcomposition || "",
      morning: item.morning ? "1" : "0",
      evening: item.evening ? "1" : "0",
      afternoon: item.afternoon ? "1" : "0",
      night: item.night ? "1" : "0",
      timing:
        item.beforefood && item.afterfood
          ? "Before & After Food"
          : item.beforefood
          ? "Before Food"
          : item.afterfood
          ? "After Food"
          : "",
      frequency: item.frequency || "",
      dosageforprescription:
        item?.dosage && item?.dosageunit ? item?.dosage + item?.dosageunit : "",
      duration: calculateDateDifference(item.medicationstartdate, item.medicationenddate),
      customtext: item.custommessage || "",
      frequencytime: item.frequencytime || "",
      frequencyvalue: item.frequencyvalue || "",
      applicationtiming: item.applicationtiming || "",
      wheretoapply: item.wheretoapply || "",
      quantity: item.quantity || "",
    };
  });
}

function formatOrders(orders) {
  const result = [];

  // Iterate through each order type (e.g., "lab", "imaging")
  for (const orderType in orders) {
    if (orders.hasOwnProperty(orderType) && orderType !== "medications") {
      const orderList = orders[orderType];
      
      if (Array.isArray(orderList)) {
        let formattedOrders = []; // Stores formatted orders for this type
        let firstOrder = true; // Flag to track the first order

        for (const order of orderList) {
          if (order && order.ordername) {
            const formattedOrder = `${order.entitytype.charAt(0).toUpperCase() + order.entitytype.slice(1)}: ${order.ordername}`;
            
            // If it's the first order, add the label
            if (firstOrder) {
              formattedOrders.push(formattedOrder); // Add the first order with label
              firstOrder = false; // Set flag to false after the first order
            } else {
              // For subsequent orders, just add the name without the label
              formattedOrders.push(order.ordername);
            }
          }
        }

        // Join all the formatted orders (first with label, rest comma-separated)
        result.push(formattedOrders.join(", "));
      }
    }
  }

  return result;
}


// used in overview screens and not on prescription
function mergeOrders(orderprocedure, orderimaging, orderlab) {
  // Initialize an empty array to store the merged result
  let mergedOrders = [];

  // Check if orderprocedure array exists and is not empty
  if (orderprocedure && Array.isArray(orderprocedure)) {
    // Iterate over orderprocedure array
    orderprocedure.forEach((order) => {
      // Push object with ordertype 'procedure' and ordername to mergedOrders
      mergedOrders.push({
        ordertype: "Procedure",
        ordername: order.ordername,
      });
    });
  }

  // Check if orderimaging array exists and is not empty
  if (orderimaging && Array.isArray(orderimaging)) {
    // Iterate over orderimaging array
    orderimaging.forEach((order) => {
      // Push object with ordertype 'imaging' and ordername to mergedOrders
      mergedOrders.push({
        ordertype: "Imaging",
        ordername: order.ordername,
      });
    });
  }

  // Check if orderlab array exists and is not empty
  if (orderlab && Array.isArray(orderlab)) {
    // Iterate over orderlab array
    orderlab.forEach((order) => {
      // Push object with ordertype 'lab' and ordername to mergedOrders
      mergedOrders.push({
        ordertype: "Lab",
        ordername: order.ordername,
      });
    });
  }

  // Return the merged array
  return mergedOrders;
}
function processROSData(rosData, visitDate) {
  if (!Array.isArray(rosData)) {
    return [];
  }

  return rosData
    .filter((item) => {
      // If visitDate is provided, you can add logic here to filter by date
      // Currently skipped since your data doesn't include a date field
      return true;
    })
    .map((item) => {
      const condition = item.rosvalue?.map(val => val.value).join(", ") || "";

      return {
        id: item.id,
        type: item.rosname,
        rosvalue: item.rosvalue,
        condition,
        patientid: item.patientid,
        doctorid: item.doctorid,
        appointmentid: item.appointmentid,
      };
    });
}



export {
  extractDiagnosis,
  formatMedicalHistory,
  transformVitalData,
  transformInvestigationData,
  transformFetchedDocuments,
  calculateAge,
  formatMedicines,
  formatOrders,
  mergeOrders,
  formatGeneralNotes,
  formatDieticianNotes,
  processROSData
};
